/**
 * @name Footer
 * @description Componente común footer de Talentry
 * @author Ricardo Guerra
 */

import React from 'react';
import i18n from 'i18next';
import styled from 'styled-components';
import moment from 'moment';
import { Link } from 'react-router-dom';

import { Lines } from '@components';
import { MUI, Typography } from '@styles';

const URL = 'https://assets.talentry.io/legal/T%C3%89RMINOS+Y+CONDICIONES+TALENTRY.pdf';

const Footer = () => {
  return (
    <Styled.FooterWrapper>
      <Lines
        direction="horizontal"
        firstLine={{ size: 25, color: 'purple' }}
        secondLine={{ size: 75, color: 'blueMedium' }}
      />
      <Styled.FlexFooter>
        <Typography.Text>
          {`${moment().format('YYYY')}, Talentry. ${i18n.t('Footer.allRightsReserved')}`}
        </Typography.Text>

        <Styled.Divider orientation="vertical" />

        {/* <Link to="">Feedback</Link>*/}

        <Styled.Link to="/notice-privacy">
          {i18n.t('Footer.noticePrivacy')}
        </Styled.Link>

        <Styled.Divider orientation="vertical" />

        <Typography.TextLink href={URL} target="_blank" rel="noopener noreferrer">
          {i18n.t('Footer.termsUse')}
        </Typography.TextLink>

        {/* <Link to="">Preguntas frecuentas</Link>*/}
      </Styled.FlexFooter>
    </Styled.FooterWrapper>
  );
};

// *************************************
// STYLED COMPONENTS                               
// *************************************

const Styled = {};

Styled.FooterWrapper = styled.footer`
	position: absolute;
  width: 100%;
	height: 64px;
	bottom: 0;

	@media (max-width: 600px) {
		position: initial;
  }
`;

Styled.FlexFooter = styled.div`
	display: flex;
  flex-direction: row;
	align-items: center;
	justify-content: center;
	height: 60px;
  padding: 16px;
`;

// Link Router
Styled.Link = styled(Link)`
  color: ${(props) => props.theme.colors.blueDark};
  letter-spacing: 0.0175em;
  line-height: 1.3;
  text-decoration: none;
  transition: .5s all;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;

Styled.Divider = styled(MUI.Divider)`
	margin: 0px 16px;
  height: 18px;
`;

export default Footer;